var _path, _path2, _polyline, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDcThunderstorms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dc_thunderstorms") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.78,1.17A36.13,36.13,0,1,0,73.9,37.3,36.17,36.17,0,0,0,37.78,1.17Zm0,70.25A34.13,34.13,0,1,1,71.9,37.3,34.17,34.17,0,0,1,37.78,71.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.25,25.09a7.22,7.22,0,0,0-2.19.35,9.12,9.12,0,0,0-16.31-4.67,10.5,10.5,0,0,1,5.65,6.91,9.59,9.59,0,0,1,1.07-.06,8.53,8.53,0,0,1,7.92,11.8h4.49a5.62,5.62,0,0,0,4.18-1.86,7.16,7.16,0,0,0-4.81-12.47Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "37.69 38.39 33.16 44.87 39.82 44.87 33.16 56.96 33.16 49.4 25.66 49.4 30.02 38.39 37.69 38.39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.47,29a7,7,0,0,0-2.2.35,9.13,9.13,0,0,0-18.22.9,9.64,9.64,0,0,0,.18,1.8h-1.7a5.64,5.64,0,0,0,0,11.28H27L29.09,38l.25-.63H39.62L38.51,39l-3.07,4.39H43.1a5.64,5.64,0,0,0,4.18-1.87A7.16,7.16,0,0,0,42.47,29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcThunderstorms);
export default __webpack_public_path__ + "static/media/dc_thunderstorms.c29a0e832454a6b7bc115680cc08bed3.svg";
export { ForwardRef as ReactComponent };